export default [
    {
        path: '/',
        name: 'public.home',
        components: {
            default: () => import('../views/public/home/index.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        }
    },
    {
        path: '/faqs',
        name: 'public.help',
        components: {
            default: () => import('../views/public/help/index.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        }
    },
    {
        path: '/contact',
        name: 'public.contact',
        components: {
            default: () => import('../views/public/contact/index.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        }
    },
    {
        path: '/events',
        name: 'public.events',
        components: {
            default: () => import('../views/public/event/index.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        }
    },
    {
        path: '/catalogue',
        name: 'public.catalogue',
        components: {
            default: () => import('../views/public/catalogue/index.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        },
        props: {
            default: true
        }
    },
    {
        path: '/catalogue/courses/:courseSlug',
        name: 'public.catalogue.course',
        components: {
            default: () => import('../views/public/course/index.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        },
        props: {
            default: true
        }
    },
    {
        path: '/catalogue/collections/:collectionSlug',
        name: 'public.catalogue.collection',
        components: {
            default: () => import('../views/public/collection/index.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        },
        props: {
            default: true
        }
    },
    {
        path: '/join',
        name: 'public.join',
        components: {
            default: () => import('@/modules/registration/views/Public.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        },
        redirect: '/',
        meta: {
            middleware: {
                // redirectIfAuthenticated: true
            }
        }
    },
    {
        path: '/memberships',
        redirect: '/join'
    },
    {
        path: '/memberships/:type',
        redirect: '/join'
    },
    {
        path: '/registration/completed',
        name: 'public.registration.completed',
        components: {
            default: () => import('@/modules/registration/views/Completed.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        }
    },
    {
        path: '/login',
        name: 'public.login',
        components: {
            default: () => import('../views/public/auth/login.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        },
    },
    {
        path: '/reset',
        name: 'public.resetPassword',
        components: {
            default: () => import('../views/public/auth/reset.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        }
    },
    {
        path: '/terms',
        name: 'public.terms',
        components: {
            default: () => import('../views/public/terms/index.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        }
    },
    {
        path: '/privacy',
        name: 'public.privacy',
        components: {
            default: () => import('../views/public/privacy/index.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        }
    },
    {
        path: '/team',
        name: 'public.team',
        components: {
            default: () => import('../views/public/team/index.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        }
    },
    {
        path: '/team/:authorSlug',
        name: 'public.team.author',
        components: {
            default: () => import('../views/public/team/author.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        },
        props: {
            default: true
        }
    },
    // {
    //     path: '/promo',
    //     name: 'public.promo',
    //     components: {
    //         default: () => import('../views/public/promo/index.vue'),
    //         header: () => import('../views/public/header/index.vue'),
    //         footer: () => import('../views/public/footer/index.vue')
    //     },
    // },
    {
        path: '/about-us',
        name: 'public.aboutUs',
        components: {
            default: () => import('../views/public/about/index.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        }
    },
    {
        path: '/social-impact',
        name: 'public.socialImpact',
        components: {
            default: () => import('../views/public/socialImpact/index.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        }
    },
    {
        path: '/premium',
        redirect: '/about-us'
    },
    // {
    //     path: '/promo/renew',
    //     redirect: '/about-us'
    // },
    {
        path: '/referral',
        name: 'public.referral',
        components: {
            default: () => import('@/modules/referral/views/Index.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        }
    },
    {
        path: '/crisis-resources',
        name: 'public.crisisResources',
        components: {
            default: () => import('../views/public/crisisResources/index.vue'),
            header: () => import('../views/public/header/index.vue'),
            footer: () => import('../views/public/footer/index.vue')
        }
    }
]

